// STUB — to be replaced by the missions agent. Must export `MissionSystem`.
import { G } from './ctx';
import type { IMissionSystem } from './types';

export class MissionSystem implements IMissionSystem {
  activeName: string | null = null;
  completed: string[] = [];
  earned = 0;
  update(dt: number): void {
    void dt;
    void G;
  }
  fail(reason: string): void {
    void reason;
    this.activeName = null;
  }
  serialize() {
    return { completed: [...this.completed], earned: this.earned };
  }
  restore(s: { completed: string[]; earned: number }): void {
    this.completed = [...s.completed];
    this.earned = s.earned;
  }
}
